import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Alert from "@material-ui/lab/Alert";
import instance from "api/globalaxios";
import Axios from "axios";
import FormattedMessage from "features/common/TranslatedMessage";
import {
  blockInvalidChar,
  getProfileTiacDispute,
  getTempDetails,
  StyledTextFieldTiac,
} from "features/Temp_IIDRC_Form/ClaimantPage/questions";
import { updateDisputeTiac } from "features/Temp_IIDRC_Form/UploadPage/questions";
import { useFormik } from "formik";
import debounce from "lodash.debounce";
import React, { useCallback, useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getPlatform } from "slices/disputeSlice";
import { getRealhost } from "slices/disputeSlice";
import { getCountries } from "slices/profileSlice";
import * as Yup from "yup";

const useStyles = makeStyles((theme) => ({
  formContainer: {
    padding: "2rem",
    height: "100%",
  },
  select: {
    "&:after": {
      borderBottomColor: "#2F80ED",
    },
  },

  guestbtn: {
    // width: "10%",
    // height : "50%",
    height: "100%",
    background: "#101C50",
    borderRadius: "4px",
    color: "#FFFFFF",
    textTransform: "none",
    "&:hover": {
      background: "#FFFFFF",
      color: "#101C50",
      border: "1px solid #101C50",
    },
  },
  vectorImage: {
    width: "10%",
    height: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "65%",
      order: 1,
      marginBottom: "2rem",
    },
    [theme.breakpoints.down("xs")]: {
      width: "80%",
      order: 1,
      marginBottom: "2rem",
    },
  },

  text: {
    fontWeight: "500",
  },

  text1: {
    "font-size": "18px",
    // color: "#2C3345",
    padding: "1rem",
  },

  text2: {
    "font-size": "18px",
    color: "#464d5f",
    padding: "0 1rem",
  },
  text3: {
    "font-size": "18px",
    color: "#464d5f",
  },

  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  required: {
    color: "#f23a3c",
  },
  guestbtn: {
    background: "#101C50",
    borderRadius: "4px",
    color: "#FFFFFF",
    textTransform: "none",
    "&:hover": {
      background: "#FFFFFF",
      color: "#101C50",
      border: "1px solid #101C50",
    },
  },
  btnTextWhite: {
    color: "#fff",
    fontWeight: "400",
    textTransform: "none",
  },
  btnTextBlack: {
    color: "#4F4F4F",
    fontSize: "16px",
    fontWeight: "400",
    textTransform: "none",
  },
}));

const SignupSchemaNotRequired = Yup.object().shape({
  email: Yup.string().email("Invalid email"),
});

let signUpData = {};

const RespLawyerPage = ({ setActiveStep, submitDetailsSignal }) => {
  const cancelTokenRef = useRef();
  const [fetchedProfile, setFetchedProfile] = useState();
  const [isAutofilled, setIsAutofilled] = useState(false);
  const [disabledFields, setDisabledFields] = useState({
    full_name: false,
    address: false,
    city: false,
    region: false,
    postal_code: false,
    country: false,
    phone_number: false,
    fax: false,
  });

  function clearAutofill() {
    formik.setFieldValue("full_name", "");
    formik.setFieldValue("phone_number", "");
    formik.setFieldValue("fax", "");
    formik.setFieldValue("address", "");
    formik.setFieldValue("city", "");
    formik.setFieldValue("region", "");
    formik.setFieldValue("postal_code", "");
    setCountry("-");
    setDisabledFields({
      full_name: false,
      address: false,
      city: false,
      region: false,
      postal_code: false,
      country: false,
      phone_number: false,
      fax: false,
    });
  }

  useEffect(() => {
    if (fetchedProfile) {
      autoFill(fetchedProfile);
    } else {
      if (isAutofilled) {
        clearAutofill();
        setIsAutofilled(false);
      }
    }
  }, [fetchedProfile]);

  let id = localStorage.getItem("dispute_id");
  let localstorageEmail = localStorage.getItem("email");

  function autoFill(fetchedProfile) {
    formik.setFieldTouched("email", false);
    formik.setFieldTouched("full_name", false);
    formik.setFieldTouched("phone_number", false);
    formik.setFieldTouched("address", false);
    formik.setFieldTouched("city", false);
    formik.setFieldTouched("region", false);
    formik.setFieldTouched("postal_code", false);
    formik.setFieldValue("email", fetchedProfile.user.email);
    formik.setFieldValue(
      "full_name",
      fetchedProfile.name ? fetchedProfile.name : ""
    );
    formik.setFieldValue(
      "phone_number",
      fetchedProfile.phone_number ? fetchedProfile.phone_number : ""
    );
    formik.setFieldValue("fax", fetchedProfile.fax ? fetchedProfile.fax : "");
    formik.setFieldValue(
      "address",
      fetchedProfile.address ? fetchedProfile.address : ""
    );
    formik.setFieldValue(
      "city",
      fetchedProfile.city ? fetchedProfile.city : ""
    );
    formik.setFieldValue(
      "region",
      fetchedProfile.region ? fetchedProfile.region : ""
    );
    formik.setFieldValue(
      "postal_code",
      fetchedProfile.postal_code ? fetchedProfile.postal_code : ""
    );
    setCountry(fetchedProfile.country ? fetchedProfile.country : "-");
    setDisabledFields({
      full_name: !!fetchedProfile.name,
      phone_number: !!fetchedProfile.phone_number,
      fax: !!fetchedProfile.fax,
      address: !!fetchedProfile.address,
      city: !!fetchedProfile.city,
      region: !!fetchedProfile.region,
      postal_code: !!fetchedProfile.postal_code,
      country: !!fetchedProfile.country && fetchedProfile.country !== "-",
    });
    setIsAutofilled(true);
  }
  const [dispute, setDispute] = useState();

  async function getDisputeTiac(email, dispute_id) {
    const platform = getPlatform();
    return await instance.get(
      `/api/tiacdisputeanonymous/?id=${dispute_id}&email=${email}&platform=${platform}`
    );
  }

  useEffect(() => {
    if (id) {
      getProfileTiacDispute(localstorageEmail, id, "respondent_lawyer")
        .then((res) => {
          if (res && res.data && res.data.user) {
            setFetchedProfile(res.data);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [id, localstorageEmail]);

  React.useEffect(() => {
    getDisputeTiac(localstorageEmail, id)
      .then((res) => {
        if (res.data.results[0].id) {
          setDispute(res.data.results[0]);
          getProfileTiacDispute(
            localstorageEmail,
            id,
            "respondent_lawyer"
          ).then((res) => {
            if (res.data.user) {
              // setFetchedProfile(res.data);
              // autoFill(res.data);
            }
          });
        } else history.push("/RFA");
      })
      .catch((e) => {
        history.push("/RFA");
      });
  }, []);

  function getProfiles(email, cancelToken) {
    return async (dispatch) => {
      try {
        const response = await instance.get(
          `/api/tiacanonymousemailautofill/?email=${email}`,
          { cancelToken: cancelToken.token }
        );
        return response.data;
      } catch (error) {
        console.log(error);
      }
    };
  }

  const getAutofillProfiles = (email) => {
    try {
      const trimmedEmail = email ? email.trim() : "";
      if (trimmedEmail === "") {
        return;
      }
      if (cancelTokenRef.current) {
        cancelTokenRef.current.cancel("Operation canceled due to new request.");
      }
      let x = Axios.CancelToken.source();
      cancelTokenRef.current = x;
      dispatch(getProfiles(trimmedEmail, x)).then((res) => {
        if (
          res &&
          res.results &&
          res.results.length > 0 &&
          res.results[0].user.email.trim() == trimmedEmail &&
          res.results[0].profile_type == "lawyer_rv"
        ) {
          let profile = res.results[0];
          profile["name"] =
            res.results[0].user.first_name +
            " " +
            res.results[0].user.last_name;
          setFetchedProfile(profile);
        } else {
          setFetchedProfile(null);
        }
      });
    } catch (e) {
      console.log(e);
    }
  };

  const handleEmailChange = useCallback(debounce(getAutofillProfiles, 500), []);

  const classes = useStyles();
  const dispatch = useDispatch();

  const [allCountries, setallCountries] = useState([]);
  const [country, setCountry] = useState("-");

  React.useEffect(() => {
    getCountries().then((res) => {
      let result = [...res];
      result.sort(function (a, b) {
        var nameA = a.name.toUpperCase();
        var nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      setallCountries(result);
    });
  }, []);

  let history = useHistory();

  async function TiaccreateprofileDisputeId(data) {
    return await instance.post(`/tiaccreateprofile/?host=${getRealhost()}`, data);
  }

  const formik = useFormik({
    initialValues: {
      full_name: "",

      address: "",
      city: "",
      region: "",
      postal_code: "",
      phone_number: "",
      email: "",
      fax: "",
    },

    validationSchema: SignupSchemaNotRequired,

    onSubmit: async (values) => {
      if (values.email) {
        values.email = values.email.trim();
      }
      let {
        full_name,
        address,
        city,
        region,
        postal_code,
        phone_number,
        email,
        fax,
      } = values;

      signUpData = values;
      let data = {
        email: email,
        profile_type: "lawyer_rv",
        for: "respondent",
        dispute_id: id,
        group: getRealhost(),
        host: getRealhost(),
        full_name: full_name,
        address: address,
        city: city,
        region: region,
        postal_code: postal_code,
        country: country == "-" ? null : country,
        phone_number: phone_number,
        fax: fax,
      };
      TiaccreateprofileDisputeId(data).then((res) => {
        updateDisputeTiac(
          {
            id: id,
            rv_respondent_lawyer_step_complete: true,
          },
          localstorageEmail
        ).then(() => {
          setActiveStep(4);
        });
      });
    },
  });

  useEffect(() => {
    const trimmedEmail = formik.values.email ? formik.values.email.trim() : "";
    if (trimmedEmail !== "") {
      if (fetchedProfile && fetchedProfile.user.email.trim() === trimmedEmail) {
        return;
      }
      if (isAutofilled) {
        clearAutofill();
        setIsAutofilled(false);
      }
      handleEmailChange(trimmedEmail);
    } else {
      clearAutofill();
      setIsAutofilled(false);
    }
  }, [formik.values.email]);


  useEffect(() => {
    if (submitDetailsSignal) {
      let {
        full_name,
        address,
        city,
        region,
        postal_code,
        phone_number,
        email,
        fax,
      } = formik.values;
      let data = {
        email: formik.values.email,
        profile_type: "lawyer_rv",
        for: "respondent",
        dispute_id: id,
        group: getRealhost(),
        host: getRealhost(),
      };
      if (full_name.trim() != "") data.full_name = full_name;
      if (address.trim() != "") data.address = address;
      if (city.trim() != "") data.city = city;
      if (region.trim() != "") data.region = region;
      if (postal_code.trim() != "") data.postal_code = postal_code;
      if (country && country != "-") data.country = country;
      if (fax.trim() != "") data.fax = fax;
      let ph = "" + phone_number;
      if (ph.trim() != "") data.phone_number = ph;

      let isComplete = !(
        email.trim() == "" ||
        full_name.trim() == "" ||
        address.trim() == "" ||
        city.trim() == "" ||
        region.trim() == "" ||
        postal_code.trim() == "" ||
        country == "-" ||
        ph.trim() == ""
      );

      TiaccreateprofileDisputeId(data).then((res) => {
        updateDisputeTiac(
          {
            id: id,
            rv_respondent_lawyer_step_complete: isComplete,
          },
          localstorageEmail
        ).then(() => {
          history.push("/resumerfa?random=" + Math.random());
        });
      });
    }
  }, [submitDetailsSignal, country, history, id, localstorageEmail]);

  return (
    <Box p="2rem 0 7rem 0">
      <Grid container spacing={3} justify="center">
        {/* <Grid item xs></Grid> */}
        <Grid item xs={11}>
          <Paper className={classes.formContainer}>
            {" "}
            <Box>
              <Typography variant="h4" className={classes.text}>
                4. Legal representative of the Respondent (if applicable)
              </Typography>
              <Box height="1rem"></Box>
              <form className={classes.form} onSubmit={formik.handleSubmit}>
                <Grid container spacing={3} justify="flex-start">
                  <Grid item md={12} sm={12} xs={12}>
                    <Typography className={classes.text1}>
                      4.1. Email address
                    </Typography>
                    <Grid
                      item
                      md={5}
                      sm={10}
                      xs={12}
                      style={{ padding: "0 1rem" }}
                    >
                      <StyledTextFieldTiac
                        variant="outlined"
                        margin="normal"
                        value={formik.values.email}
                        autoFocus
                        fullWidth
                        id="email"
                        name="email"
                        autoComplete="email"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                      />
                        {formik.errors.email && formik.touched.email && (
                          <Alert severity="error">{formik.errors.email}</Alert>
                        )}
                      </Grid>
                      <Grid
                        item
                        md={4}
                        sm={4}
                        xs={12}
                        style={{ padding: "0 1rem" }}
                      >
                      </Grid>
                    <Box height="1rem"></Box>

                    <Typography className={classes.text2}>
                      example@example.com
                    </Typography>
                  </Grid>
                  <Grid item md={12} sm={12} xs={12}>
                    <Typography className={classes.text1}>
                      4.2. Full name:{" "}
                    </Typography>
                    <Grid
                      item
                      md={5}
                      sm={10}
                      xs={12}
                      style={{ padding: "0 1rem" }}
                    >
                      <StyledTextFieldTiac
                        // required
                        variant="outlined"
                        margin="normal"
                        value={formik.values.full_name}
                        disabled={disabledFields.full_name}
                        fullWidth
                        id="full_name"
                        name="full_name"
                        autoComplete="full_name"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.full_name && formik.touched.full_name && (
                        <Alert severity="error">
                          {formik.errors.full_name}
                        </Alert>
                      )}
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ padding: "0 1rem" }}
                  >
                    <Typography className={classes.text1}>
                      4.3. Address:
                    </Typography>
                    <Grid
                      item
                      md={10}
                      sm={10}
                      xs={12}
                      style={{ padding: "0 1rem" }}
                    >
                      <StyledTextFieldTiac
                        variant="outlined"
                        margin="normal"
                        value={formik.values.address}
                        disabled={disabledFields.address}
                        fullWidth
                        id="address"
                        name="address"
                        autoComplete="address"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                      />
                    </Grid>
                    <Typography className={classes.text2}>
                      Apartment and Street
                    </Typography>
                    <Grid container style={{ padding: "0 1rem" }}>
                      <Grid
                        item
                        md={5}
                        sm={10}
                        xs={12}
                        style={{ paddingRight: "0.5rem" }}
                      >
                        <StyledTextFieldTiac
                          variant="outlined"
                          margin="normal"
                          value={formik.values.city}
                          disabled={disabledFields.city}
                          fullWidth
                          id="city"
                          name="city"
                          autoComplete="city"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                        />
                        <Typography className={classes.text3}>
                          Сity (Town)
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        md={5}
                        sm={10}
                        xs={12}
                        style={{ paddingLeft: "0.5rem" }}
                      >
                        <StyledTextFieldTiac
                          variant="outlined"
                          margin="normal"
                          value={formik.values.region}
                          disabled={disabledFields.region}
                          fullWidth
                          id="region"
                          name="region"
                          autoComplete="region"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                        />
                        <Typography className={classes.text3}>
                          Region and State
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      md={10}
                      sm={10}
                      xs={12}
                      style={{ padding: "0 1rem" }}
                    >
                      <StyledTextFieldTiac
                        variant="outlined"
                        margin="normal"
                        value={formik.values.postal_code}
                        disabled={disabledFields.postal_code}
                        fullWidth
                        id="postal_code"
                        name="postal_code"
                        autoComplete="postal_code"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                      />
                    </Grid>
                    <Typography className={classes.text2}>
                      Postal code
                    </Typography>
                    <Box height="2rem"></Box>
                    <Grid
                      item
                      md={6}
                      sm={8}
                      xs={12}
                      style={{ padding: "1rem" }}
                    >
                      <FormControl fullWidth>
                        {/* <InputLabel id="demo-simple-select-label">
                          Country
                        </InputLabel> */}
                        <Select
                          labelId="demo-country-select-label"
                          id="demo-country-select"
                          value={country}
                          disabled={disabledFields.country} className={classes.select}
                          onChange={(e) => {
                            setCountry(e.target.value);
                          }}
                        >
                          <MenuItem value={"-"}>---</MenuItem>
                          {allCountries.map((country) => {
                            return (
                              <MenuItem key={country.id} value={country.id}>
                                {country.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Typography className={classes.text2}>
                      Country
                    </Typography>
                  </Grid>
                  <Box height="2rem" />
                  <Grid
                    item
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ padding: "0 1rem", marginTop: "1.5rem" }}
                  >
                    <Typography className={classes.text1}>
                      4.4. Telephone number
                    </Typography>
                    <Grid
                      item
                      md={10}
                      sm={12}
                      xs={12}
                      style={{ padding: "0 1rem" }}
                    >
                      <Grid item md={5} sm={10} xs={12}>
                        <StyledTextFieldTiac
                          // required
                          type="number"
                          variant="outlined"
                          margin="normal"
                          value={formik.values.phone_number}
                          disabled={disabledFields.phone_number}
                          fullWidth
                          id="phone_number"
                          name="phone_number"
                          autoComplete="phone_number"
                          onKeyDown={blockInvalidChar}
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                        />
                        <Box height="1rem"></Box>
                      </Grid>
                    </Grid>
                    <Typography
                      className={classes.text3}
                      style={{ padding: "0 1rem" }}
                    >
                      Please enter only numerals and a valid contact
                      number
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ padding: "0 1rem", marginTop: "1.5rem" }}
                  >
                    <Typography className={classes.text1}>
                      4.5. Fax
                    </Typography>
                    <Grid
                      item
                      md={5}
                      sm={10}
                      xs={12}
                      style={{ padding: "0 1rem" }}
                    >
                      <StyledTextFieldTiac
                        variant="outlined"
                        margin="normal"
                        value={formik.values.fax}
                        disabled={disabledFields.fax}
                        fullWidth
                        id="fax"
                        name="fax"
                        autoComplete="fax"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Box height="4rem"></Box>
                <Grid container justify="center" spacing={3}>
                  <Grid item>
                    <Box display="flex" justifyContent="center">
                      <Button
                        type="submit"
                        variant="contained"
                        style={{ background: "#2F80ED" }}
                      >
                        <Typography className={classes.btnTextWhite}>
                          <FormattedMessage id="buttons.proceed" />
                        </Typography>
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Paper>
        </Grid>
        {/* <Grid item xs /> */}
      </Grid>
    </Box>
  );
};

export default RespLawyerPage;
